<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            :range="true"
            label="작업기간"
            name="permitDates"
            v-model="searchParam.permitDates"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            type="search"
            codeGroupCd="SOP_SUPPLEMENT_WORK_TYPE_CD"
            itemText="codeName"
            itemValue="code"
            name="supplementWorkTypeCd"
            label="보충작업"
            v-model="searchParam.supplementWorkTypeCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            type="search"
            stepperGrpCd="SWP_STEP_CD"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="swpStepCd"
            label="진행단계"
            v-model="searchParam.swpStepCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="tasktable"
      title="작업허가서 목록"
      :columns="grid.columns"
      :data="grid.data"
      :columnSetting="false"
      :isFullScreen="false"
      :usePaging="false"
      :expandAll="true"
      selection="multiple"
      rowKey="sopWorkPermitId"
      @linkClick="linkClick"
    >
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn
            v-if="editable"
            label="삭제"
            icon="remove"
            @btnClicked="deleteTask"
          />
          <c-btn
            v-if="editable"
            label="추가"
            icon="add"
            @btnClicked="addTask"
          />
          <!-- 검색 -->
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "constructionRelactionTaskWorkPermit",
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        sopConstructionId: "",
      }),
    },
    task: {
      type: Object,
      default: () => ({
        insertUrl: "",
        deleteUrl: "",
      }),
    },
  },
  data() {
    return {
      searchParam: {
        plantCd: null,
        permitDates: [],
        supplementWorkTypeCd: null,
        swpStepCd: null,
        sopConstructionId: "",
        constructionFlag: true,
      },
      grid: {
        columns: [
          {
            // 사업장
            name: "plantName",
            field: "plantName",
            label: "사업장",
            align: "center",
            sortable: true,
            style: "width:80px",
          },
          {
            // 작업개요
            name: "workSummary",
            field: "workSummary",
            label: "작업개요",
            align: "left",
            sortable: true,
            type: "link",
            style: "width:250px",
          },
          {
            // 진행단계
            name: "swpStepName",
            field: "swpStepName",
            label: "진행단계",
            align: "center",
            sortable: true,
            style: "width:100px",
          },
          {
            // 결재진행단계
            name: "approvalStatusName",
            field: "approvalStatusName",
            label: "결재진행단계",
            align: "center",
            sortable: true,
            style: "width:100px",
          },
          {
            // 허가일
            name: "permitDate",
            field: "permitDate",
            label: "허가일",
            align: "center",
            sortable: true,
            style: "width:100px",
          },
          {
            // 보충작업
            name: "supplementWorkTypeNames",
            field: "supplementWorkTypeNames",
            label: "보충작업",
            align: "left",
            sortable: true,
            style: "width:200px",
          },
          {
            // 신청부서
            name: "applicationDeptName",
            field: "applicationDeptName",
            label: "신청부서",
            align: "center",
            sortable: true,
            style: "width:100px",
          },
          {
            // 발급부서
            name: "issuedDeptName",
            field: "issuedDeptName",
            label: "발급부서",
            align: "center",
            sortable: true,
            style: "width:100px",
          },
          {
            name: "tbmExists",
            field: "tbmExists",
            label: "TBM 여부",
            align: "center",
            sortable: true,
            style: "width:70px",
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: "",
      popupOptions: {
        isFull: false,
        width: "80%",
        target: null,
        title: "",
        visible: false,
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.swp.workPermit.list.url;
      // code setting
      this.$set(
        this.searchParam,
        "sopConstructionId",
        this.popupParam.sopConstructionId,
      );
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col, index) {
      this.popupOptions.title = "작업허가서";
      this.popupOptions.param = {
        sopWorkPermitId: row ? row.sopWorkPermitId : "",
        permitTypeCd: row ? row.permitTypeCd : "",
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/swp/safeWorkPermitDetail.vue"}`);
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    deleteTask() {
      let selectData = this.$refs["tasktable"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "안내",
          message: "제외할 행을 지정하세요.", // 제외할 행을 지정하세요.
          type: "warning", // success / info / warning / error
        });
      } else {
        window.getApp.$emit("CONFIRM", {
          title: "확인",
          message: "삭제하시겠습니까?",
          // TODO : 필요시 추가하세요.
          type: "info", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.task.deleteUrl;
            this.$http.type = "DELETE";
            this.$http.param = {
              data: Object.values(
                this.$_.map(selectData, (item) => {
                  return {
                    sopConstructionId: this.popupParam.sopConstructionId,
                    sopWorkPermitId: item.sopWorkPermitId,
                  };
                }),
              ),
            };
            this.$http.request((_result) => {
              window.getApp.$emit("APP_REQUEST_SUCCESS");
              this.$refs["tasktable"].$refs["compo-table"].clearSelection();
              this.getList();
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      }
    },
    addTask() {
      this.popupOptions.title = "작업허가서 검색"; // 작업허가서 검색
      this.popupOptions.param = {
        type: "multiple",
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/swp/safeWorkPermitPop.vue"}`);
      this.popupOptions.width = "80%";
      this.popupOptions.isFull = false;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeTaskPopup;
    },
    closeTaskPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let insertList = [];
        this.$_.forEach(data, (item) => {
          if (
            this.$_.findIndex(this.grid.data, {
              sopWorkPermitId: item.sopWorkPermitId,
            }) === -1
          ) {
            insertList.push({
              sopConstructionId: this.popupParam.sopConstructionId,
              sopWorkPermitId: item.sopWorkPermitId,
            });
          }
        });

        this.$http.url = this.task.insertUrl;
        this.$http.type = "POST";
        this.$http.param = insertList;
        this.$http.request(() => {
          window.getApp.$emit("APP_REQUEST_SUCCESS");
          this.getList();
        });
      }
    },
  },
};
</script>
